import { configurePaymentComponent } from '../payment-panel/payment-orchestrator';
import { configureExpressPaymentComponent } from '../express-payment-panel/express-payment-orchestrator';
import { ComponentConfig, ComponentName } from '../types/external/component';
import { PaymentComponentConfig, PaymentComponentInstance } from '../types/external/payment-component';
import { ExpressPaymentComponentConfig, ExpressPaymentComponentInstance } from '../types/external/express-payment-component';
import { logger } from './logger';

/**
 * Main ESW Components SDK class that serves as the entry point for the API
 */
export class ESWComponents {
  constructor(globalConfig: ComponentConfig) {
    logger.info('ESWComponents initialized with', globalConfig);
    this.globalConfig = globalConfig;
  }

  private readonly globalConfig: ComponentConfig;

  create(name: 'payment-panel', config: PaymentComponentConfig): PaymentComponentInstance;
  create(name: 'express-payment-panel', config: ExpressPaymentComponentConfig): ExpressPaymentComponentInstance;
  create(
    name: ComponentName,
    config: PaymentComponentConfig | ExpressPaymentComponentConfig
  ): PaymentComponentInstance | ExpressPaymentComponentInstance {
    if (!name) {
      logger.error('Component name is required');
      throw new Error('Component name is required');
    }

    const mergedConfig = {
      ...this.globalConfig,
      ...config
    };

    if (name === 'payment-panel') {
      return configurePaymentComponent(mergedConfig as PaymentComponentConfig);
    } else if (name === 'express-payment-panel') {
      return configureExpressPaymentComponent(mergedConfig as ExpressPaymentComponentConfig);
    } else {
      throw new Error(`Component ${name} is not supported`);
    }
  }
}
